/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIbm = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 8v.545h3.892V8zm4.445 0v.545h5.547S11.426 8 10.674 8zm6.637 0v.545h3.355l-.2-.545zm5.76 0-.197.545h3.323V8zM2 9.06v.545h3.892V9.06zm4.445 0v.545h6.192s-.074-.42-.2-.544zm6.637 0v.545h3.723l-.184-.544zm5.363 0-.184.545h3.707V9.06zM3.118 10.122v.546h1.687v-.546zm4.445 0v.546H9.25v-.546zm3.327 0v.546h1.684c.002 0 .108-.289.108-.546zm3.31 0v.546h2.99l-.2-.546zm3.876 0-.2.546h3.006v-.546zM3.118 11.183v.545h1.687v-.545zm4.445 0v.545h4.305s.36-.28.477-.545zm6.637 0v.545h1.684v-.304l.108.304h3.09l.113-.304v.304h1.687v-.545h-3.166l-.169.462-.168-.462zm-11.082 1.06v.545h1.687v-.545zm4.445 0v.545h4.782c-.116-.265-.477-.545-.477-.545zm6.637 0v.545h1.684v-.545zm1.992 0 .203.545h2.316l.194-.545zm3.003 0v.545h1.687v-.545zm-16.077 1.06v.546h1.687v-.546zm4.445 0v.546H9.25v-.546zm3.327 0v.546h1.792c0-.257-.108-.546-.108-.546zm3.31 0v.546h1.684v-.546zm2.374 0 .197.546h1.553l.2-.546zm2.62 0v.546h1.688v-.546zm-17.162 1.06v.548h3.892v-.548zm4.413 0v.548h5.992c.126-.126.2-.548.2-.548zm6.666 0v.548h2.773v-.548zm3.847 0 .203.548h.789l.192-.548zm2.237 0v.548H22v-.548zM2.032 15.426v.545h3.892v-.545zm4.413 0v.545h4.229c.752 0 1.318-.545 1.318-.545zm6.666 0v.545h2.773v-.545zm4.231 0 .198.542.031.003.2-.545zm1.853 0v.545H22v-.545z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgIbm as Ibm };
